// 인증 관련 상수
export const VERIFICATION_CODE_LENGTH = 6;
export const VERIFICATION_TIMEOUT_SECONDS = 600; // 10분

// 비밀번호 관련 상수
export const MIN_PASSWORD_LENGTH = 8;
export const MIN_PASSWORD_STRENGTH_SCORE = 3;
export const STRONG_PASSWORD_THRESHOLD = 4;
export const MAX_PASSWORD_STRENGTH_SCORE = 5;

// 이름 관련 상수
export const MIN_NAME_LENGTH = 2;
export const MAX_NAME_LENGTH = 50;

// 비밀번호 길이 보너스 기준
export const PASSWORD_LENGTH_BONUS_THRESHOLD_1 = 12;
export const PASSWORD_LENGTH_BONUS_THRESHOLD_2 = 16;
